import { render, staticRenderFns } from "./ContactsKanban.vue?vue&type=template&id=f59eab8a&scoped=true&"
import script from "./ContactsKanban.vue?vue&type=script&lang=js&"
export * from "./ContactsKanban.vue?vue&type=script&lang=js&"
import style0 from "./ContactsKanban.vue?vue&type=style&index=0&id=f59eab8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f59eab8a",
  null
  
)

export default component.exports